export enum PromotionApprovalStatus {
  NotRequired = 'NotRequired',
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
}
